import { configureStore } from "@reduxjs/toolkit";
import coeSlice from "../components/coe/coeSlice";
import inmatesReducer from "../components/inmate_list/inmatesSlice";
import tabAdvancedReducer from "../components/tab_advanced/tabAdvancedSlice";
export default configureStore({
  reducer: {
    inmates: inmatesReducer,
    tabAdvanced: tabAdvancedReducer,
    coe: coeSlice,
  },
});
